<img [appOgImage]="attributes" [attr.class]="imageClass" [src]="attributes.src" [attr.srcset]="srcsetAttribute" [alt]="attributes.alt" (load)="loaded.emit($event)" (error)="loaded.emit($event)" [appEditorId]="editorIds?.src">
